<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden compact-sidebar"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-20">
            <!-- <img class="w-8" src="assets/images/logo/favicon1.png" alt="Logo image"> -->
            <img *ngIf="view.site && (view.site.agencyID == 23 || view.site.id == 47)" class="w-48 mt-2" src="https://platform.travelfind.me/uploads/site/logo/xl-holidays-logo-no-tagline.png" alt="Logo image">
            <img *ngIf="view.site && view.site.id == 147" class="w-24 mt-3" src="https://platform.travelfind.me/uploads/site/logo/whitestar-logo-light.png" alt="Logo image">
            <img *ngIf="view.site && !(view.site.agencyID == 23 || view.site.id == 47) && view.site.id != 147" class="w-48 mt-2" src="https://platform.travelfind.me/assets/images/brand/logo1.png" alt="Logo image">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <div class="flex items-center pr-2 space-x-2">
            <!-- Navigation toggle button -->
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button
                class="hidden md:inline-flex"
                mat-icon-button
                (click)="toggleNavigationAppearance()">
                <mat-icon [svgIcon]="'heroicons_outline:arrows-right-left'"></mat-icon>
            </button>
        </div>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <languages></languages> -->
            <div *ngIf="view.itin" class="flex flex-col items-start space-y-1">
                <span class="font-medium text-base">
                    {{ view.itin.content.itinerary.firstName + ' ' + view.itin.content.itinerary.lastName }}
                </span>
                <div class="flex items-center space-x-2 text-gray-400 text-xs">
                    <span>{{ view.itin.content.itinerary.emailAddress }}</span>
                    <span class="text-gray-300">|</span>
                    <span>{{ view.itin.content.itinerary.reference }}</span>
                </div>
            </div>
            
            <search [appearance]="'bar'"></search>
            <!-- <shortcuts></shortcuts>
            <messages></messages> -->
            <notifications></notifications>
            <button
                class="ml-4"
                mat-flat-button
                [color]="'primary'"
                (click)="openSearchOptions()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">New</span>
            </button>
            <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button>
            <user [showSummary]="true"></user>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>

            <!-- <changelog-notification></changelog-notification> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
            Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Dynamic cart section -->
    @if (view.isClient && view.data.cart && view.data.cart.length > 0) {
    <mat-drawer class="m-auto dark:bg-gray-900 transition-all duration-500 fixed bottom-0 shadow-2xl w-11/12 bg-white pb-3 rounded-t-lg border-2 border-b-0 border-primary opacity-0" [class.z-99]="view.data.cart && view.data.cart.length > 0" [class.opacity-[97]]="view.data.cart && view.data.cart.length > 0 || view.itinGuid" [position]="'end'" [autoFocus]="false" [mode]="view.drawerOptions && view.drawerOptions.mode == 'review' ? 'side' : drawerMode" [disableClose]="false" [opened]="view.data.cart && view.data.cart.length > 0" #drawerRight>
        <cart [options]="{loadCache:false, isClient:view.isClient, compactColumns: true}" (viewChange)="viewChanged($event)" (quoteCreated)="quoteCreated($event)"></cart>
    </mat-drawer>
    }

    <!-- Footer -->
    <footer></footer>

</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
